"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require("react-redux");

var _recompose = require("recompose");

var _glamor = require("glamor");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _components = require("components");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _DropdownMenu = require("@quixeltools/quixel-ui-library/dist/components/common/website/DropdownMenu");

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _Icon = require("@quixeltools/quixel-ui-library/dist/components/common/website/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _auth = require("redux/modules/auth");

var authActions = _interopRequireWildcard(_auth);

var _notifications = require("redux/modules/notifications");

var notificationsActions = _interopRequireWildcard(_notifications);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderAccountIcon = function renderAccountIcon() {
  return _react2.default.createElement("img", {
    src: "https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/account.svg",
    width: 32,
    height: 32
  });
};

var renderNotificationsIcon = function renderNotificationsIcon() {
  return _react2.default.createElement("img", {
    src: "https://d3uwib8iif8w1p.cloudfront.net/megascans/icons/notifications.svg",
    width: 32,
    height: 32
  });
};

var renderAccountDropdown = function renderAccountDropdown(props) {
  return _react2.default.createElement(
    "div",
    { style: { textAlign: "left" } },
    _react2.default.createElement(_components.AccountDropdown, props)
  );
};

var renderNotificationsDropdown = function renderNotificationsDropdown(props) {
  return _react2.default.createElement(
    "div",
    { style: { textAlign: "left" } },
    _react2.default.createElement(_components.NotificationDropdown, props)
  );
};

var menuContainer = (0, _glamor.css)({
  position: "relative",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
});

var dot = (0, _glamor.css)({
  position: "absolute",

  width: "10px",
  height: "10px",
  background: _css.pallets.blue_primary,
  borderRadius: "10px",
  left: "18px",
  top: "1px",
  zIndex: "1"
});
var buttonFonts = (0, _glamor.css)({
  "& a": {
    fontSize: "18px !important",
    background: _css.pallets.blue_primary,
    //backgroundBlendMode: 'color, normal',
    //backgroundImage: `linear-gradient(to bottom, ${pallets.blue_gradient}, ${pallets.blue_primary}), linear-gradient(135deg, ${pallets.alternateGreen}, ${pallets.green})`,
    border: "none !important"
  }
}, (0, _css.maxWidth)("3840px")({
  "& a": {
    fontSize: "16px !important"
  }
}), (0, _css.maxWidth)("3240px")({
  "& a": {
    fontSize: "14px !important"
  }
}));

var seperator = (0, _glamor.css)({
  marginRight: "24px"
});

var renderLoggedInState = function renderLoggedInState(props, subscribeButton) {
  return _react2.default.createElement(
    "span",
    { className: menuContainer },
    subscribeButton && _react2.default.createElement(
      "div",
      { className: (0, _glamor.css)(buttonFonts, seperator) },
      _react2.default.createElement(_Button2.default, { smaller: true, to: "/pricing", label: "SUBSCRIBE" })
    ),
    _react2.default.createElement(
      "div",
      { style: { position: "relative" } },
      props.notifications && props.notifications[0] && props.notifications[0].isNew && _react2.default.createElement("div", { className: dot }),
      _react2.default.createElement(_DropdownMenu2.default, {
        align: "right",
        menus: [{
          icon: renderNotificationsIcon(),
          dropdown: renderNotificationsDropdown({
            notifications: props.notifications
          }),
          onClose: props.handleNotificationsIconClick
        }, {
          icon: renderAccountIcon(),
          dropdown: renderAccountDropdown({
            username: _ramda2.default.toLower(_ramda2.default.propOr("", "email", props.user)),
            points: _ramda2.default.pathOr(0, ["quota", "currentQuota"], props.user),
            isUnlimited: !!_ramda2.default.pathOr(0, ["quota", "isUnlimited"], props.user),
            refillIn: props.user.subscription ? (0, _moment2.default)(_ramda2.default.pathOr(0, ["subscription", "expiresAt"], props.user)).add(2, "days").diff((0, _moment2.default)(), "days") : null,
            plans: _ramda2.default.pathOr(null, ["plansDecorated"], props.subscriptions),
            planId: _ramda2.default.pathOr(null, ["subscription", "planId"], props.user),
            doesGetCharged: _ramda2.default.pathOr(null, ["subscription", "doesGetCharged"], props.user),
            license: _ramda2.default.pathOr(null, ["subscription", "license"], props.user),
            isActive: _ramda2.default.pathOr(false, ["subscription", "isActive"], props.user),
            type: _ramda2.default.pathOr(false, ["subscription", "planId"], props.user),

            accountTo: "/account",
            onAddPointsClick: props.handleAddPointsClick,
            // onSettingsClick: props.handleSettingsClick,
            onDownloadAppsClick: "/apps",
            onDownloadBridgeClick: "/bridge",
            onDownloadMixerClick: "/mixer",
            onSubscribeClick: "/pricing",
            onSignoutClick: props.handleSignoutClick
          })
        }]
      })
    )
  );
};

var renderLoggedOutState = function renderLoggedOutState() {
  return _react2.default.createElement(
    "div",
    { className: buttonFonts },
    _react2.default.createElement(_Button2.default, { smaller: true, to: "/pricing", label: "SUBSCRIBE" })
  );
};

var SiteHeaderMenu = function SiteHeaderMenu(props) {
  var dayDif = false;

  if (!_underscore2.default.isEmpty(props.user.megascansTrial)) {
    var a = (0, _moment2.default)(props.user.megascansTrial.expiresAt);
    var b = (0, _moment2.default)();

    dayDif = a.diff(b, "days") < 0;
  }

  var _props$user = props.user,
      subscription = _props$user.subscription,
      megascansTrial = _props$user.megascansTrial;


  var flag = false;
  var trial = false;
  var subscribed = subscription && subscription.isActive;
  if (!subscribed) {
    if (!_underscore2.default.isEmpty(megascansTrial)) {
      trial = true;
    } else {
      trial = false;
    }
  } else {
    flag = true;
  }

  return props.loggedIn ? renderLoggedInState(props, !props.user.subscription || props.user.subscription && !props.user.subscription.isActive) : renderLoggedOutState(props);
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn,
    user: state.user,
    subscriptions: state.subscriptions,
    notifications: state.notifications,
    currentpage: state.routing && state.routing.locationBeforeTransitions ? state.routing.locationBeforeTransitions.pathname : ""
  };
}, {
  logout: authActions.logout,
  markAsSeen: notificationsActions.markAsSeen
})((0, _recompose.compose)((0, _recompose.getContext)({
  dialogs: _react2.default.PropTypes.object
}), (0, _recompose.withHandlers)({
  handleSettingsClick: function handleSettingsClick(_ref) {
    var dialogs = _ref.dialogs;
    return function () {
      return dialogs.custom(_react2.default.createElement(_components.DownloadSettingsPopup, null));
    };
  },
  handleAddPointsClick: function handleAddPointsClick(_ref2) {
    var dialogs = _ref2.dialogs;
    return function () {
      return dialogs.custom(_react2.default.createElement(_components.AddPointsPopup, null));
    };
  },
  handleSignoutClick: function handleSignoutClick(_ref3) {
    var logout = _ref3.logout;
    return function () {
      return logout();
    };
  },
  handleNotificationsIconClick: function handleNotificationsIconClick(_ref4) {
    var markAsSeen = _ref4.markAsSeen;
    return function () {
      return markAsSeen();
    };
  }
}))(SiteHeaderMenu));
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteHeaderMenu/SiteHeaderMenu.jsx
// module id = 2782
// module chunks = 0